import React from "react";
import { Grid } from "@material-ui/core";

import { EXECUTION_BRIEF_HOOK } from "../../../pages/execution-brief/types/execution-brief-template.interface";
import { TemplateName } from "../../../types/templates/template-name";
import { UserGroup } from "../../../constants/types";
import { useExecutionBriefTemplateOptions } from "../../../pages/execution-brief/types/execution-brief-template.hooks";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { RichTextField } from "../../forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { TextField } from "../../forms/fields/text-field/text-field.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";

import {
  ARE_VENDOR_ASSETS_PROVIDED,
  FLYER_PERIOD,
  HAS_VENDOR_COMMITMENT,
  LANGUAGES,
  MERCH_OWNERS,
  PROJECT_OVERVIEW,
  VENDOR_ASSETS_LOCATION,
} from "../constants";

import { IExecutionBriefTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const ExecutionBriefWebTemplate = (props: IExecutionBriefTemplate) => {
  const { languagesOptions } = useExecutionBriefTemplateOptions([EXECUTION_BRIEF_HOOK.LANGUAGES]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={PROJECT_OVERVIEW.TITLE}
            name={PROJECT_OVERVIEW.ID}
            required
            subTitle={TemplateName.ExecutionBrief.Web}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <TextField
            form={props.form}
            label={FLYER_PERIOD.TITLE}
            name={FLYER_PERIOD.ID}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <SelectField
            form={props.form}
            label={LANGUAGES.TITLE}
            multiple
            name={LANGUAGES.ID}
            options={languagesOptions}
            placeholder="Select Language"
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            groupFilter={UserGroup.MERCH_OWNERS}
            label={MERCH_OWNERS.TITLE}
            name={MERCH_OWNERS.ID}
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={HAS_VENDOR_COMMITMENT.TITLE}
            name={HAS_VENDOR_COMMITMENT.ID}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={ARE_VENDOR_ASSETS_PROVIDED.TITLE}
            name={ARE_VENDOR_ASSETS_PROVIDED.ID}
            userPermissions={props.userPermissions}
          >
            <RichTextField
              form={props.form}
              label={VENDOR_ASSETS_LOCATION.TITLE}
              name={VENDOR_ASSETS_LOCATION.ID}
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
